"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultThemeColors = exports.serializeTypebot = exports.deserializeHttpRequests = exports.deserializeCredentials = exports.deserializeMetaData = exports.deserializeStartConditions = exports.deserializeVariables = exports.deserializeSteps = exports.deserializeSettings = exports.deserializeTheme = exports.deserializeTypebot = void 0;
const deserializeTypebot = (typebot) => {
    var _a, _b;
    return ({
        version: 2,
        createdDate: new Date(typebot.created_date),
        modifiedDate: new Date(typebot.modified_date),
        customDomains: (_a = typebot.custom_domains) !== null && _a !== void 0 ? _a : [],
        theme: (0, exports.deserializeTheme)(typebot.theme),
        language: typebot.language,
        name: (_b = typebot.name) !== null && _b !== void 0 ? _b : "",
        ownerId: typebot.owner_id,
        settings: (0, exports.deserializeSettings)(typebot.settings),
        steps: (0, exports.deserializeSteps)(typebot.steps),
        variables: (0, exports.deserializeVariables)(typebot.variables),
        collaborators: typebot.collaborators,
        connectors: deserializeConnectors(typebot.connectors),
        embedHrefs: typebot.embed_hrefs,
        folderId: typebot.folder_id,
        startConditions: (0, exports.deserializeStartConditions)(typebot.start_conditions),
        metaData: (0, exports.deserializeMetaData)(typebot.meta_data),
        webhooks: deserializeWebhooks(typebot.webhooks),
        checkedConversionRules: typebot.checked_conversion_rules,
        credentials: (0, exports.deserializeCredentials)(typebot.credentials),
        httpRequests: (0, exports.deserializeHttpRequests)(typebot.http_requests),
        id: typebot.id,
    });
};
exports.deserializeTypebot = deserializeTypebot;
// TO-DO real type checking
const deserializeTheme = (theme) => {
    var _a, _b;
    if (typeof theme !== "object" || !theme)
        return { colors: exports.defaultThemeColors, fontFamily: "Inter" };
    const verifiedTheme = theme;
    return {
        colors: (_a = verifiedTheme.colors) !== null && _a !== void 0 ? _a : exports.defaultThemeColors,
        fontFamily: (_b = verifiedTheme.fontFamily) !== null && _b !== void 0 ? _b : "Inter",
    };
};
exports.deserializeTheme = deserializeTheme;
const deserializeSettings = (settings) => {
    var _a;
    return (_a = settings) !== null && _a !== void 0 ? _a : {
        showLiteBadge: true,
        showCreateYourOwnButton: true,
    };
};
exports.deserializeSettings = deserializeSettings;
const deserializeSteps = (steps) => {
    if (!Array.isArray(steps))
        return [];
    return steps;
};
exports.deserializeSteps = deserializeSteps;
const deserializeVariables = (variables) => {
    var _a;
    return (_a = variables) !== null && _a !== void 0 ? _a : {
        computationVariables: [],
        questionVariables: [],
        starterVariables: [],
    };
};
exports.deserializeVariables = deserializeVariables;
const deserializeConnectors = (connectors) => connectors;
const deserializeStartConditions = (startConditions) => startConditions;
exports.deserializeStartConditions = deserializeStartConditions;
const deserializeMetaData = (metaData) => metaData;
exports.deserializeMetaData = deserializeMetaData;
const deserializeWebhooks = (webhooks) => webhooks;
const deserializeCredentials = (credentials) => credentials;
exports.deserializeCredentials = deserializeCredentials;
const deserializeHttpRequests = (httpRequests) => httpRequests;
exports.deserializeHttpRequests = deserializeHttpRequests;
const serializeTypebot = (typebot) => ({
    id: typebot.id,
    created_date: typebot.createdDate,
    modified_date: typebot.modifiedDate,
    checked_conversion_rules: typebot.checkedConversionRules,
    owner_id: typebot.ownerId,
    collaborators: typebot.collaborators,
    connectors: typebot.connectors,
    custom_domains: typebot.customDomains,
    embed_hrefs: typebot.embedHrefs,
    folder_id: typebot.folderId,
    language: typebot.language,
    meta_data: typebot.metaData,
    name: typebot.name,
    settings: typebot.settings,
    start_conditions: typebot.startConditions,
    steps: typebot.steps,
    theme: typebot.theme,
    variables: typebot.variables,
    webhooks: typebot.webhooks,
    credentials: typebot.credentials,
    http_requests: typebot.httpRequests,
});
exports.serializeTypebot = serializeTypebot;
exports.defaultThemeColors = {
    buttonColor: {
        active: {
            backgroundColor: { value: "#0042DA" },
            textColor: { value: "#ffffff" },
        },
        inactive: {
            backgroundColor: { value: "#EDF2F7" },
            textColor: { value: "#303235" },
        },
    },
    chatbotBackground: {
        value: "#ffffff",
    },
    siteBackground: {
        value: "#F7F8FF",
    },
    hostBubble: {
        backgroundColor: { value: "#F7F8FF" },
        textColor: { value: "#303235" },
    },
    guestBubble: {
        backgroundColor: {
            value: "#FF8E21",
        },
        textColor: {
            value: "#ffffff",
        },
    },
};
//# sourceMappingURL=typebots.js.map